import { render } from "./NewCustomerPopup.vue?vue&type=template&id=bbdbc54c&scoped=true"
import script from "./NewCustomerPopup.vue?vue&type=script&lang=js"
export * from "./NewCustomerPopup.vue?vue&type=script&lang=js"

import "./NewCustomerPopup.vue?vue&type=style&index=0&id=bbdbc54c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbdbc54c"]])

export default __exports__